import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TokenService } from './token.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _tokenService: TokenService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token: string = this._tokenService.getTokenStorage();

    // const token =
    //   'eyJ4NXQiOiJOMkpqTWpOaU0yRXhZalJrTnpaalptWTFZVEF4Tm1GbE5qZzRPV1UxWVdRMll6YzFObVk1TlEiLCJraWQiOiJNREpsTmpJeE4yRTFPR1psT0dWbU1HUXhPVEZsTXpCbU5tRmpaalEwWTJZd09HWTBOMkkwWXpFNFl6WmpOalJoWW1SbU1tUTBPRGRpTkRoak1HRXdNQV9SUzI1NiIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiJnYWJyYWxsQHRzdC5jb20iLCJhdXQiOiJBUFBMSUNBVElPTl9VU0VSIiwiYXVkIjoiT1hvdG5HUGlFV182ME5vTkxBQUs4OG1iUWUwZCIsIm5iZiI6MTY4MjUzMDczNiwiYXpwIjoiT1hvdG5HUGlFV182ME5vTkxBQUs4OG1iUWUwZCIsInNjb3BlIjoiZW1haWwgb3BlbmlkIHByb2ZpbGUiLCJpc3MiOiJodHRwczpcL1wvc3NvLm5leHBlLmNvXC9vYXV0aDJcL3Rva2VuIiwiZ3JvdXBzIjpbIkludGVybmFsXC9hZG1pbiIsIm1vZGZpbl9hcHJvdmFjYW8iLCJBcHBsaWNhdGlvblwvQ3JlZGlNb3JhciBGaW5hbmNpYWxTZXJ2aWNlcyIsIkFwcGxpY2F0aW9uXC9Db25zb2xlIiwiSW50ZXJuYWxcL3N5c3RlbSIsIkludGVybmFsXC9ldmVyeW9uZSIsIm1vZGZpbl9mYXR1cmFtZW50byIsIkFwcGxpY2F0aW9uXC9NeSBBY2NvdW50IiwiYWRtaW4iLCJtb2RmaW5fcmVwYXNzZSIsIkFwcGxpY2F0aW9uXC9wb3J0YWxjb3JyZXRvciIsIkFwcGxpY2F0aW9uXC9wb3J0YWxjb3JyZXRvcl9uZXhwZV9kZXYiXSwiZXhwIjoxNjgyNTM0MzM2LCJpYXQiOjE2ODI1MzA3MzYsImp0aSI6Ijc5ZTcyMWQ1LTU5NGItNDgzMS1iOTNiLWZiOTRiOTEzYTEwNiIsImVtYWlsIjoidCJ9.ZvDKYUfptwKrEhXjs1jDhMTMWippAQJdjHWP9hVQKlvSN-PqT31riDimfiV7U03sdoVllRbnRgPdtNPbUvr0Y7gHwq75v77jr_x1MkSvZvcmLp4GUSiVzwqRhkPdjcz27AVCCE9y1SVNwYw4wknQ21f07Ij_Aj3I7llJ9c1kc6aLm4BGFzxFokpFsFRG9uzE0_caL37nxDs0amYSA5VOlEJhOVtMEDWRQwk1H83kYYIbP6yP2IGhdEIP9GGO84VkPR50yLR25XseqAmf7r_NYiSD14E0yRRAR44LMhYd8gIFVGb4gnub3RO4B8WIvJmljUh-RMX6F9dEKq-5sq5Vgg';

    const req = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    return next.handle(req);
  }
}
